export const removeInvisibleCharacters = (value: string): string =>
   value.replace(/[^\x20-\x7E]/g, '')

export const checkIsNumber = (value: string) => /\d+/g.test(value)
